<template>
  <div class="page-container">
    <div class="page-header">
      <div class="header-content">
        <h2>贷款申请审批</h2>
        <span class="desc">查看和管理贷款申请</span>
      </div>
      <div class="header-actions">
        <el-input
          v-model="queryParams.contactName"
          placeholder="搜索申请人..."
          class="search-input"
          @input="handleSearch"
        />
        <el-select
          v-model="queryParams.type"
          class="type-select"
          placeholder="全部类型"
          @change="handleTypeChange"
        >
          <el-option
            v-for="item in productTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <div class="list-container">
      <!-- 状态筛选标签 -->
      <div class="status-tabs">
        <el-radio-group
          v-model="queryParams.status"
          @change="handleStatusChange"
        >
          <el-radio-button
            v-for="item in applicationStateList"
            :key="item.value"
            :label="item.value"
          >{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>

      <!-- 贷款申请列表 -->
      <div
        v-if="loanApplicationList.length"
        v-loading="loading"
        class="application-list"
      >
        <div
          v-for="application in loanApplicationList"
          :key="application.id"
          class="application-card"
        >
          <div class="card-header">
            <div class="applicant-info">
              <div
                :class="[
                  'company-icon',
                  application.supplyLoanApplyEnterprise
                    ? 'icon-blue'
                    : 'icon-green'
                ]"
              >
                <!-- <i :class="application.icon" /> -->
                {{ application.supplyLoanApplyEnterprise ? '企' : '农' }}
              </div>
              <div class="info-content">
                <h3 class="company-name">
                  {{
                    application.supplyLoanApplyEnterprise
                      ? application.supplyLoanApplyEnterprise.companyName
                      : application.contactName || '-'
                  }}
                </h3>
                <p class="application-time">
                  申请时间: {{ application.createTime }}
                  <span v-if="application.approvalTime" class="approval-time">
                    | 审批时间: {{ application.approvalTime }}
                  </span>
                </p>
              </div>
              <el-tag
                :type="applicationTagMap[application.status]"
                size="small"
              >
                {{ applicationStateMap[application.status] }}
              </el-tag>
            </div>
          </div>

          <div class="card-body">
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">申请产品</span>
                <span class="detail-value">{{
                  application.productName || '-'
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">申请金额</span>
                <span
                  class="detail-value"
                >{{ application.fundsAmount || '-' }}万</span>
              </div>
              <!-- <div class="detail-item">
                <span class="detail-label">贷款期限</span>
                <span
                  class="detail-value"
                >{{ application.term || '-' }}月</span>
              </div> -->
              <div class="detail-item">
                <span class="detail-label">联系人</span>
                <span class="detail-value">{{
                  application.contactName || '-'
                }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">联系电话</span>
                <span class="detail-value">{{
                  application.contactPhone || '-'
                }}</span>
              </div>

              <!-- <div v-if="application.approvalUserName" class="detail-item">
                <span class="detail-label">审批人</span>
                <span class="detail-value">{{
                  application.approvalUserName || '-'
                }}</span>
              </div> -->
            </div>

            <div class="purpose-section">
              <span class="detail-label">资金用途:</span>
              <span class="purpose-text">{{
                application.fundsUses || '-'
              }}</span>
            </div>
            <!-- <div v-if="application.annualIncome" class="detail-item">
              <span class="detail-label">年销售收入</span>
              <span
                class="detail-value"
              >{{ application.annualIncome || '-' }}万元</span>
            </div>
            <div v-if="application.plantArea" class="detail-item">
              <span class="detail-label">种植面积</span>
              <span
                class="detail-value"
              >{{ application.plantArea || '-' }}亩</span>
            </div>
            <div v-if="application.plantVarieties" class="crops-section">
              <span class="detail-label">主要种植:</span>
              <span class="crops-text">{{ application.plantVarieties }}</span>
            </div> -->
          </div>

          <div class="card-actions">
            <el-button
              type="primary"
              size="small"
              @click="handleViewDetail(application)"
            >
              <i class="el-icon-view" /> 查看详情
            </el-button>
            <el-button
              v-if="application.status === 0"
              type="success"
              size="small"
              @click="handleApprove(application, 1)"
            >
              <i class="el-icon-check" /> 通过
            </el-button>
            <el-button
              v-if="application.status === 0"
              type="danger"
              size="small"
              @click="handleApprove(application, 2)"
            >
              <i class="el-icon-close" /> 拒绝
            </el-button>
          </div>
        </div>
      </div>
      <el-empty
        v-else
        style="margin-top: 150px"
        image="https://oss.yungia.cn/yjkjoss/group1/M00/01/7D/wKgBcmlCScKAWpSFAAAozJyBfZA665.png"
        image-style="height: 120px"
        description="暂无贷款申请信息"
      />
    </div>
    <!-- 分页 -->
    <div class="pagination-container">
      <pub-pagination
        :total="total"
        :page-num="queryParams.pageNum"
        :page-size="queryParams.pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <apply-detail-dialog
      :visible="showDetailDialog"
      :apply-data="selectedApplication"
      @close="handleCloseDetailDialog"
    />

    <!-- 审批拒绝弹框 -->
    <el-dialog
      title="审批拒绝"
      :visible.sync="showRejectDialog"
      width="400px"
      :close-on-click-modal="false"
      @close="handleCloseRejectDialog"
    >
      <el-form
        ref="rejectFormRef"
        :model="rejectForm"
        label-position="top"
        :rules="rejectRules"
      >
        <el-form-item label="审批原因" prop="auditOpinion" required>
          <el-input
            v-model="rejectForm.auditOpinion"
            type="textarea"
            :rows="4"
            placeholder="请输入审批拒绝原因"
            resize="none"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseRejectDialog">取消</el-button>
        <el-button type="primary" @click="handleConfirmReject">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pubPagination from '@/components/pubPagination.vue';
import constants from '@/utils/constants.js';
import { api_getLoanApplicationPageList, api_approval } from '@/api/loans.js';
import applyDetailDialog from './components/applyDetailDialog.vue';
export default {
  name: 'LoanApplication',
  components: {
    pubPagination,
    applyDetailDialog
  },
  data() {
    return {
      // 弹窗控制
      showDetailDialog: false,
      selectedApplication: {},
      // 审批拒绝弹框
      showRejectDialog: false,
      currentApplication: null,
      rejectForm: {
        auditOpinion: ''
      },
      // 表单验证规则
      rejectRules: {
        auditOpinion: [
          { required: true, message: '请输入审批原因', trigger: 'blur' }
          // { min: 10, message: '审批原因至少10个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      applicationStateMap: constants.applicationStateMap,
      applicationTagMap: constants.applicationTagMap,
      // 分页控制
      total: 80,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contactName: '',
        type: '',
        status: ''
      },
      // 贷款申请列表数据
      loanApplicationList: []
    };
  },
  computed: {
    applicationStateList() {
      return [{ label: '全部', value: '' }, ...constants.applicationStateList];
    },
    productTypeList() {
      return [{ label: '全部类型', value: '' }, ...constants.productTypeList];
    }
  },
  mounted() {
    // 初始化加载数据
    this.getList();
  },
  methods: {
    // 处理搜索
    handleSearch() {
      this.pageNum = 1;
      this.getList();
    },

    // 处理类型筛选
    handleTypeChange() {
      this.refreshList(true);
    },

    // 处理状态标签切换
    handleStatusChange() {
      // this.queryParams.productState = tab.name;
      this.refreshList(true);
    },
    refreshList(reload = false) {
      // 刷新产品列表数据
      if (reload) {
        this.queryParams.pageNum = 1;
      }
      this.getList();
    },
    // 加载申请列表数据
    async getList() {
      // 模拟加载数据
      // 实际项目中应该调用API获取数据
      this.loading = true;
      try {
        const res = await api_getLoanApplicationPageList(this.queryParams);
        this.loanApplicationList = res.data.rows || [];
        this.total = res.data.total || 0;
        this.loading = false;
      } catch (error) {
        console.error('获取产品列表失败:', error);
        this.loading = false;
      }
    },

    // 查看详情
    handleViewDetail(application) {
      this.selectedApplication = application;
      this.showDetailDialog = true;
    },

    // 关闭详情弹窗
    handleCloseDetailDialog() {
      this.showDetailDialog = false;
      this.selectedApplication = {};
    },

    // 审批处理
    handleApprove(application, status) {
      if (status === 2) {
        // 拒绝审批
        this.currentApplication = application;
        this.rejectForm.auditOpinion = '';
        this.showRejectDialog = true;
      } else {
        // 通过审批
        this.$confirm('确定要通过该贷款申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'success'
        })
          .then(async() => {
            // 模拟审批通过
            try {
              await api_approval({
                id: application.id,
                status: status,
                approvalRemark: ''
              });
              this.$message.success('审批通过成功');
              this.refreshList();
            } catch (error) {
              console.error('审批操作失败:', error);
              // this.$message.error('审批操作失败，请稍后重试');
            }
          })
          .catch(() => {
            // this.$message.info('已取消审批');
          });
      }
    },

    // 关闭拒绝弹框
    handleCloseRejectDialog() {
      this.showRejectDialog = false;
      this.currentApplication = null;
      this.rejectForm.auditOpinion = '';
      this.$refs.rejectFormRef.resetFields();
    },

    // 确认拒绝审批
    async handleConfirmReject() {
      // 验证表单
      this.$refs.rejectFormRef.validate(async(valid) => {
        if (valid) {
          try {
            await api_approval({
              id: this.currentApplication.id,
              status: 2,
              approvalRemark: this.rejectForm.auditOpinion
            });
            this.$message.success('已拒绝');
            this.showRejectDialog = false;
            this.currentApplication = null;
            this.rejectForm.auditOpinion = '';
            this.refreshList();
          } catch (error) {
            console.error('审批操作失败:', error);
            // this.$message.error('审批操作失败，请稍后重试');
          }
        }
      });
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.queryParams.pageSize = size;
      this.queryParams.pageNum = 1;
      this.getList();
    },

    // 当前页码变化
    handleCurrentChange(current) {
      this.queryParams.pageNum = current;
      this.getList();
    }
  }
};
</script>

<style scoped>
/* 页面特定样式，公共样式已在global-styles.css中定义 */
.header-actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.search-input {
  width: 200px;
}

.type-select {
  width: 150px;
}

.status-tabs {
  margin-bottom: 10px;
  background-color: #fff;
  padding: 10px 10px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.application-list {
  margin-bottom: 20px;
}

.application-card {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-bottom: 15px;
  transition: box-shadow 0.3s ease;
}

.application-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.card-header {
  margin-bottom: 15px;
}

.applicant-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.company-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.company-icon.icon-blue {
  background-color: #ecf5ff;
  color: #409eff;
}

.company-icon.icon-green {
  background-color: #f0f9eb;
  color: #67c23a;
}

.company-icon.icon-purple {
  background-color: #f5f0ff;
  color: #909399;
}

.info-content {
  flex: 1;
}

.company-name {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 5px 0;
  color: #333;
}

.application-time {
  font-size: 12px;
  color: #909399;
  margin: 0;
}

.approval-time {
  margin-left: 10px;
}

.card-body {
  margin-bottom: 15px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.detail-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.purpose-section,
.crops-section {
  margin-bottom: 10px;
  /* padding-left: 55px; */
}

.purpose-text,
.crops-text {
  font-size: 14px;
  color: #333;
  margin-left: 5px;
}

.card-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-actions {
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }

  .search-input,
  .type-select {
    width: 100%;
  }

  .detail-grid {
    grid-template-columns: 1fr;
  }

  .purpose-section,
  .crops-section {
    padding-left: 0;
  }

  .card-actions {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
